import { QuoteRequest } from "../apiModels/quoteRequest";
import apiPaths from "./apiPaths";
import { post } from "./apiUtilities";

export const submitQuoteRequest = async (quoteRequest: QuoteRequest) => await post(`${apiPaths.submitQuoteRequest}`, {
    body: JSON.stringify(quoteRequest)
});
